import React from 'react';

import styles from './ButtonArrow.module.scss';

interface ButtonArrowProps {
  type: 'default' | 'double';
  rotation: 'right' | 'left';
  isDisabled: boolean;
  onClick: () => void | null;
}

const ButtonArrow: React.FC<ButtonArrowProps> = ({
  type = 'default',
  rotation,
  isDisabled,
  onClick
}) => {
  const arrowIcons = `/assets/icons/${
    type === 'default' ? 'arrow' : 'double_arrow'
  }.png`;

  return (
    <button
      data-testid={`btn-arrow-${type}`}
      className={styles['btn-arrow__container']}
      disabled={isDisabled}
      onClick={() => !isDisabled && onClick()}
    >
      <img
        className={`${styles[rotation]} ${styles[type]}`}
        src={arrowIcons}
        alt={`arrow-${type}`}
      />
    </button>
  );
};

export default ButtonArrow;
